import { object, string } from 'yup';

import { SlideModel } from 'v2/types/SlideModel';

export type SlideForm = Omit<SlideModel, 'id' | 'order'>;

export const initialValues: SlideForm = {
  title: '',
  description: '',
  buttonText: '',
  link: '',
  ymId: '',
  isActive: true,
  isOrderFixed: false,
  backgroundImageId: '',
  buttonImageId: '',
  advantages: '',
};

export const validationSchema = object().shape({
  backgroundImageId: string().trim().required(),
  buttonImageId: string().trim().required(),
});
